// extracted by mini-css-extract-plugin
export default {"container":"gallery_container__lXDct","title":"gallery_title__DSftn"};